import React from 'react';
import { Chip, styled } from '@mui/material';
import theme from '../../constants/theme';

export const ChipStyled = styled(Chip)({
  borderRadius: '24px',
  background: theme.palette.light.main,
  color: theme.palette.primary.main,
  fontWeight: 600,
  '& .MuiChip-label': {
    fontSize: theme.typography.body1.fontSize,
  },
  '&:hover': {
    background: theme.palette.light.main,
  },
  svg: {
    backgroundColor: theme.palette.transparent.main,
    color: `${theme.palette.primary.main} !important`,
    fontSize: `${theme.typography.h4.fontSize} !important`,
  },
});
